import React from 'react';
import {connect} from  'react-redux';
import {Button} from 'react-bootstrap';
import HighChart from './HighChart';
import Constants from '../Constants';
import ContactInfo from '../ContactInfo';
/* eslint-disable */

class Report extends React.Component {
    render() {
        const response = this.props.getForm('response');
        const branding = this.props.branding;
        if(response && response.success){
            let chartsData = response.chartsData;
            let clientBirthYear = new Date(this.props.client.birthdate).getUTCFullYear();
            let spouseBirthYear = new Date(this.props.client.client.spouse.birthdate).getUTCFullYear();
            let clientFirstName = this.props.client.firstName;
            let spouseFirstName = this.props.client.client.spouse.firstName;

            chartsData = chartsData.map((data)=>{
                if(clientBirthYear && spouseBirthYear){
                    let obj ={
                        x: data[0],
                        y: data[1],
                        clientFirstName: clientFirstName,
                        spouseFirstName: spouseFirstName,
                        clientBirthYear: clientBirthYear,
                        spouseBirthYear: spouseBirthYear
                    }
                    return obj;
                }else{
                    let obj ={
                        x: data[0],
                        y: data[1],
                        clientFirstName: clientFirstName,
                        clientBirthYear: clientBirthYear
                    }
                    return obj;
                } 
            });
            let step = 2;
           
            let chartConfig = {
                ...Constants.HightChartsDefaultConfig
            };
            chartConfig.xAxis.labels.step = step;
            chartConfig.xAxis.labels.rotation = -60;
            let fontColor = '#FFFFFF';
            // if(branding.active){
            //     chartConfig.chart.backgroundColor = branding.headingBackColor1;
            //     chartConfig.chart.plotBorderColor = branding.headingBackColor1;
            //     chartConfig.chart.color = branding.headerFontColor;
            //     fontColor = branding.headerFontColor;
            //     chartConfig.title.style.color = fontColor;
            //     chartConfig.xAxis.labels.style.color = fontColor;
            //     chartConfig.xAxis.title.style.color = fontColor;
            //     chartConfig.yAxis.labels.style.color = fontColor;
            //     chartConfig.yAxis.title.style.color = fontColor;
            //     chartConfig.legend.itemStyle.color = fontColor;
            // }
            chartConfig.series = [{ 
                    column: {
                        pointWidth: 20,
                        color: '#007bff',
                        borderColor: '#007bff',
                        backgroundColor: '#007bff'
                    },
                    name: 'Retirement Funds',
                    data: chartsData,
                    dataLabels: {
                        enabled: false,
                        rotation: -90,
                        color: fontColor,
                        align: 'right',
                        format: '{point.y:.1f}', // one decimal
                        y: 10, // 10 pixels down from the top
                        style: {
                            color:  fontColor,
                            fontSize: '12px',
                            fontWeight:'100',
                            fontFamily: "Open Sans"
                        }
                    }
                }];
            return (
                <React.Fragment>
                    <div className='row'>
                        <div className={`col-md-12 col-sm-12`}>
                            <h4 className={'text-center'}>Report</h4>
                            <p>{typeof response.message === 'string' && response.message}</p>
                                {Array.isArray(response.message) &&
                                    response.message.map((m,i) => <p key={i}>{m}</p> )
                                }
                           
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 col-sm-12">
                            <p>Please keep in mind that this is a basic view of your retirement analysis, using the numbers you input into the Retirement Analyzer. Your Retirement Analyzer Advisor can add more detail and, in many cases, make recommendations and suggest strategies to help you attain your retirement goals and better your analysis.</p>
                            <hr/>
                            <ContactInfo getForm={this.props.getForm} processResult={this.props.processResult} />
                            <hr />
                        </div>
                    </div>
                    <div className="row">
                        <div className={`col-md-12 col-sm-12 `}>
                            <HighChart config={chartConfig} />
                        </div>
                    </div>
                    <div className={'text-center'}>
                        <br/>
                        {/* <Button type="button" onClick={() => this.props.processResult(false)} >Edit Information</Button> */}
                        <p style={{'fontSize': '10px','textAlign': 'justify'}}>
                        The information provided by these projections and calculators is for illustrative purposes only. Estimates included are based on information supplied by the client such as estimated Social Security benefits, pension benefits, projections of cost of living increases, inflation rates, and federal and state income tax rates. Current federal income tax tables are used in certain calculations. All of these are subject to change and will have an effect on the long range outcome shown in the analysis. Any interest rates are hypothetical and are not meant to represent any specific investment, the assumptions do not encompass all situations. Thomas Gold Solutions, LLC does not make any guarantees on the outcome of any recommendations made based upon the above information. The projections or other information generated by this report regarding the likelihood of various investment outcomes are hypothetical in nature, do not reflect actual investment results, and are not guarantees of future results. 
                        </p>
                    </div>
                </React.Fragment>
            );
        }
        else{
            return(
                <div className={'text-center'}>
                        <h4>Something went wrong.</h4>
                        <p>{(response && response.message) ? response.message:'Please go back and try submitting again'} </p>
                        <Button type="button" onClick={() => this.props.processResult(false)} >Go Back</Button>
                </div>
            );
        }
    }
}
const mapStateToProps = (state, ownProps) => {
    return {
        ...state.mainState.form,
        ...state.mainState,
        ...ownProps
    }
  }
  
//   const mapDispatchToProps = { globalUpdateState }
  
  export default connect(
    mapStateToProps,
    null
    // mapDispatchToProps
  )(Report)
